module.exports = __webpack_public_path__ + "img/featured-placeholder.61f8b9a6.jpg";